import * as React from "react";
import { Text } from "react-native-paper";
import PageContainer from "../../common/PageContainer";
import routes from "../../routing/routes";
import { StyleSheet, View, Image } from "react-native";
import { blackColor } from "../../common/colors";
import resolutionMargin, { widthMargin } from "../../common/resolutionMargin";
import Accordion from "../../common/Accordion";

export default (props) => {
  const onClickGoToSettings = () => {
    props.navigation.navigate(routes.Settings);
  };

  return (
    <PageContainer
      {...props}
      onClickGoToSettings={onClickGoToSettings}
      isSettingsIcon={true}
      isBackIcon={true}
      backRoute={props.user ? routes.Settings : routes.Home}
      noBackground={false}
      isResult={true}
    >
      <View style={styles.container}>
        <View style={styles.wrapper}>
          <View style={styles.titleContainer}>
            <Text style={styles.title}>{props.title}</Text>
            <Text style={styles.content}>{props.quotation}</Text>
            <View style={styles.authorContainer}>
              <Text style={styles.author}>{props.authorName}</Text>
            </View>
            <Image source={props.image} style={styles.image} />
          </View>
        </View>
      </View>
      <Accordion colorType={props.colorType} />
    </PageContainer>
  );
};
const paddingLeftItem = 15;
const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    width: "100%",
  },
  wrapper: {},
  titleContainer: {
    alignItems: "flex-start",
    width: resolutionMargin(),
    paddingLeft: 15,
    paddingRight: 15,
  },
  title: {
    textTransform: "uppercase",
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 26,
    top: 20,
    paddingLeft: paddingLeftItem,
    letterSpacing: 1.25,
    textAlign: "center",
    color: blackColor,
  },
  content: {
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 23,
    paddingLeft: paddingLeftItem,
    top: 69,
    letterSpacing: 0.75,
    color: blackColor,
    fontStyle: "italic",
  },
  authorContainer: {
    alignItems: "flex-end",
    width: 340,
    paddingLeft: 15,
    paddingRight: 15,
  },
  author: {
    fontSize: 14,
    fontWeight: "700",
    lineHeight: 23,
    top: 85,
    letterSpacing: 0.75,
    color: blackColor,
  },
  image: {
    marginTop: 45,
    height: 123,
    width: 144,
    marginLeft: -widthMargin - 5,
    resizeMode: "contain",
  },
});
